
const getCachedImageData = (cacheData) => cacheData.get('images');
const getCachedPdfData = (cacheData) => cacheData.get('pdfs');


export {getCachedImageData, getCachedPdfData}